import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageEditorModalComponent } from './image-editor-modal.component';
import { MaterialModule } from 'src/app/core/shared/util/material/material.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { LoadingPageModule } from 'src/app/features/loaders/loading-page/loading-page.module';


@NgModule({
  declarations: [ImageEditorModalComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ImageCropperModule,
    LoadingPageModule
  ],
  exports: [ImageEditorModalComponent]
})
export class ImageEditorModalModule { }
